(function () {
  var DESKTOP = 901;
  var EDGE = 16;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP + 'px)').matches;
  }

  function setHeaderHeight() {
    var header = document.querySelector('header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  function positionDropdown(item) {
    var dd = item.querySelector('.mega-dropdown');
    if (!dd) return;
    dd.style.setProperty('--mega-offset', '0px');
    var rect = dd.getBoundingClientRect();
    if (!rect.width) return;
    var shift = 0;
    if (rect.right > window.innerWidth - EDGE) {
      shift = -(rect.right - (window.innerWidth - EDGE));
    }
    if (rect.left + shift < EDGE) {
      shift = EDGE - rect.left;
    }
    dd.style.setProperty('--mega-offset', Math.round(shift) + 'px');
  }

  function measureDropdowns() {
    if (!isDesktop()) return;
    document.querySelectorAll('.mega-nav-item.has-dropdown').forEach(function (item) {
      var dd = item.querySelector('.mega-dropdown');
      if (!dd) return;
      dd.classList.add('mega-measuring');
      positionDropdown(item);
      dd.classList.remove('mega-measuring');
    });
  }

  function closeDropdowns(except) {
    document.querySelectorAll('.mega-nav-item.open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('open');
      var btn = item.querySelector('.mega-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeight();
    measureDropdowns();

    var toggle = document.getElementById('mobileMenuToggle');
    var nav = document.getElementById('megaNav');
    var backdrop = document.querySelector('[data-menu-backdrop]');
    var searchToggle = document.getElementById('headerSearchToggle');
    var searchForm = document.getElementById('headerSearch');
    var headerTop = document.querySelector('.header-top');

    function closeSearch() {
      if (!headerTop || !searchToggle) return;
      headerTop.classList.remove('search-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      setHeaderHeight();
    }

    function openSearch() {
      if (!headerTop || !searchToggle) return;
      closeMenu();
      headerTop.classList.add('search-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      setHeaderHeight();
      var input = searchForm ? searchForm.querySelector('input') : null;
      if (input) input.focus();
    }

    if (searchToggle && headerTop) {
      searchToggle.addEventListener('click', function () {
        if (headerTop.classList.contains('search-open')) closeSearch();
        else openSearch();
      });
    }

    function openMenu() {
      if (!nav || !toggle) return;
      closeSearch();
      setHeaderHeight();
      nav.classList.add('mobile-open');
      document.body.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Cerrar menu');
    }

    function closeMenu() {
      if (!nav || !toggle) return;
      nav.classList.remove('mobile-open');
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menu');
      closeDropdowns();
    }

    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        if (nav.classList.contains('mobile-open')) closeMenu();
        else openMenu();
      });
    }

    if (backdrop) backdrop.addEventListener('click', closeMenu);

    document.querySelectorAll('.mega-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = btn.closest('.mega-nav-item');
        if (!item) return;
        var willOpen = !item.classList.contains('open');
        closeDropdowns(item);
        item.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
        if (willOpen && isDesktop()) positionDropdown(item);
      });
    });

    document.querySelectorAll('.mega-nav-item.has-dropdown').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (isDesktop()) positionDropdown(item);
      });
      item.addEventListener('focusin', function () {
        if (isDesktop()) positionDropdown(item);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mega-nav-item')) closeDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDropdowns();
      closeSearch();
      if (nav && nav.classList.contains('mobile-open')) {
        closeMenu();
        if (toggle) toggle.focus();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setHeaderHeight();
        if (isDesktop()) {
          closeMenu();
          closeSearch();
          measureDropdowns();
        }
      }, 150);
    });

    if (window.ResizeObserver) {
      var header = document.querySelector('header');
      if (header) new ResizeObserver(setHeaderHeight).observe(header);
    }

    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = this.getAttribute('href');
        if (id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link');
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('copied');
          setTimeout(function () {
            btn.classList.remove('copied');
          }, 1800);
        });
      });
    });
  });

  window.addEventListener('load', function () {
    setHeaderHeight();
    measureDropdowns();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('.product-gallery-thumb');
    var images = gallery.querySelectorAll('.product-gallery-image');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-index');
        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });
        images.forEach(function (i) {
          i.classList.remove('active');
        });
        thumb.classList.add('active');
        var img = gallery.querySelector('.product-gallery-image[data-index="' + idx + '"]');
        if (img) {
          img.classList.add('active');
        }
      });
    });
  });

  document.querySelectorAll('.product-form').forEach(function (form) {
    var panel = form.closest('.product-details-panel');
    var variantsScript = panel ? panel.querySelector('[data-product-variants]') : null;
    var variantsData = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantIdInput = form.querySelector('[data-variant-id]');
    var priceEl = panel ? panel.querySelector('[data-product-price]') : null;
    var addBtn = form.querySelector('[data-add-to-cart]');
    var gallery = form.closest('.product-layout') ? form.closest('.product-layout').querySelector('.product-gallery') : null;
    var optionGroups = form.querySelectorAll('.product-option');
    var selected = {};

    optionGroups.forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var selectedBtn = group.querySelector('.product-option-value.selected');
      selected[idx] = selectedBtn ? selectedBtn.getAttribute('data-value') : null;
      group.querySelectorAll('.product-option-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.product-option-value').forEach(function (b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          selected[idx] = btn.getAttribute('data-value');
          updateVariant();
        });
      });
    });

    function updateVariant() {
      if (!variantsData.length) return;
      var match = variantsData.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          var optKey = 'option' + (parseInt(idx, 10) + 1);
          return v[optKey] === selected[idx];
        });
      });
      if (!match) return;
      if (variantIdInput) {
        variantIdInput.value = match.id;
      }
      if (priceEl) {
        priceEl.innerHTML = match.price > 0 ? match.price_formatted : '<span class="product-price-quote">Precio sobre cotizacion</span>';
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-available-text') || 'Agregar al carrito' : 'Agotado';
      }
      if (gallery && match.featured_image) {
        var targetImg = gallery.querySelector('.product-gallery-image[data-image-src="' + match.featured_image + '"]');
        if (targetImg) {
          var idx = targetImg.getAttribute('data-index');
          gallery.querySelectorAll('.product-gallery-image').forEach(function (i) {
            i.classList.remove('active');
          });
          gallery.querySelectorAll('.product-gallery-thumb').forEach(function (t) {
            t.classList.remove('active');
          });
          targetImg.classList.add('active');
          var thumb = gallery.querySelector('.product-gallery-thumb[data-index="' + idx + '"]');
          if (thumb) {
            thumb.classList.add('active');
          }
        }
      }
    }

    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) {
          qtyInput.value = v - 1;
        }
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var form = el.closest('form');
      if (form) form.submit();
    });
  });

  var cartTimer;

  function submitCartForm(form) {
    if (!form) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var updateBtn = form.querySelector('[name="update"]');
      if (updateBtn) updateBtn.click();
      else form.submit();
    }, 500);
  }

  document.querySelectorAll('.cart-item').forEach(function (row) {
    var input = row.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var form = input.closest('form');
    var minus = row.querySelector('[data-cart-qty-minus]');
    var plus = row.querySelector('[data-cart-qty-plus]');

    function bump(delta) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      v = v + delta;
      if (v < 0) v = 0;
      input.value = v;
      submitCartForm(form);
    }

    if (minus) minus.addEventListener('click', function () { bump(-1); });
    if (plus) plus.addEventListener('click', function () { bump(1); });
    input.addEventListener('change', function () { submitCartForm(form); });
  });
});
